module.exports = __webpack_public_path__ + "img/falkland_islands.f5afe7f.webp";